jQuery(document).ready(function ($) {

    if ($(window).width() > 1100) {
        $('.search-toggle').on('click', function () {
            $(this).toggleClass('active');
            $('.search-bar').toggleClass('open');
        });

        $('.search-toggle').one('click', function (e) {
            setTimeout(function () {
                $('.search-bar #search-input').focus();
            }, 300);
        });

        $('.search-bar__close').on('click', function (e) {
            $('.search-bar').removeClass('open');
        });
    }

    if ($(window).width() < 1100) {

        $('.toggle-nav').on('click', function () {
            $('.nav--main').toggleClass('show');
            $('body').toggleClass('no-scroll');
            $(".search-bar-mobile").removeClass('show');
            $('.toggle-search').removeClass('active');
        });

        $('.ham4').on('click', function () {
            $(this).toggleClass('active');
        });

        $('.toggle-search').on('click', function () {
            $(this).toggleClass('active');
            $(".search-bar-mobile").toggleClass('show');
            $('.nav--main').removeClass('show');
            $('body').removeClass('no-scroll');
            $('.ham4').removeClass('active');
            $('.search-bar-mobile input').focus();
        });

        $('.mobile-sub-toggle').on("click", function (e) {
            $(this)
                .toggleClass('active')
                .next().toggleClass('show');
        });

        $('.nav--top ul').appendTo('.nav--main');
        $('.header-wrapper__right .search-bar').appendTo('.header__main .header-wrapper__right');
    }

    $('#saldo-checker-button').click(function (e) {
        $('body').addClass('overlay');

    });

    $('#saldo-check-overlay-background, #saldo-overlay-close').click(function (e) {
        $('body').removeClass('overlay');
    });
});
